
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`contact/index`),
    saleindex: () => clientAuth.get(`salecontact/index`),
    destroy: (id) => clientAuth.delete(`contact/destroy/${id}`),
    salecontactdestroy: (id) => clientAuth.delete(`salecontact/destroy/${id}`),
	store: (userData) => clientAuth.post('contact/store', { json: userData }),
    updatecheckstatus: (userData) => clientAuth.post('contact/updatecheckstatus', { json: userData }),
    updatesalecheckstatus: (userData) => clientAuth.post('salecontact/updatecheckstatus', { json: userData }),
    updateInquiriesstatus: (id) => clientAuth.post(`notification/inquiry/update/${id}`),
};